module.exports = __webpack_public_path__ + "f26f9fcfa00c4fe73ec425f69d590e31.svg";